import React, { useState } from 'react'
import { FaVolumeOff, FaVolumeUp } from 'react-icons/fa'
import { motion } from 'framer-motion'
import ReactModal from 'react-modal'
import LearnCharacters from './LearnCharacters'

interface ExplanationProps {
  topic: {
    explanation?: string
    images?: string[]
    btnName: string
    learnCharacters: any[]
  }
  isSpeaking: boolean
  speakExplanation: any
}

const Explanation: React.FC<ExplanationProps> = ({ topic, isSpeaking, speakExplanation }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  return (
    <>
      <div className='card shadow-lg rounded-lg p-4 mb-4'>
        {/* Title */}
        <h3 className='text-primary font-weight-bold mb-3' style={{ fontSize: '2.5rem' }}>
          व्याख्या
        </h3>

        {/* Explanation Text with Speak Button */}
        <div className='d-flex align-items-start'>
          <p className='lead text-muted mb-0 flex-grow-1' style={{ fontSize: '2rem' }}>
            {topic?.explanation}
          </p>
          {topic?.explanation && (
            <button
              className='btn bg-transparent border-0 ms-3 d-flex align-items-center justify-content-center'
              onClick={() => speakExplanation(topic?.explanation)}
              style={{
                fontSize: '1.5rem',
                cursor: 'pointer',
                transition: 'transform 0.2s ease, color 0.2s ease'
              }}
              onMouseDown={(e) => e.preventDefault()} // Prevent button flickering
            >
              {isSpeaking ? (
                <FaVolumeUp className='text-dark' style={{ transform: 'scale(1.2)' }} />
              ) : (
                <FaVolumeOff className='text-secondary' style={{ transform: 'scale(1.2)' }} />
              )}
            </button>
          )}
        </div>

        {/* Images Section */}
        <div className='d-flex justify-content-center flex-wrap mt-4'>
          {topic?.images && topic.images.length > 0 ? (
            topic.images.map((image, index) => (
              <motion.img
                key={index}
                src={image}
                alt={`Explanation ${index + 1}`}
                className='img-fluid m-3 shadow-lg rounded'
                style={{ maxWidth: '400px', height: 'auto' }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              />
            ))
          ) : (
            <p className='text-danger mt-3' style={{ fontSize: '1.6rem' }}>
              कोई चित्र उपलब्ध नहीं है।
            </p>
          )}
        </div>
      </div>
      {/* <div className='d-flex justify-content-center'>
        <button
          className='btn btn-primary fw-bold'
          onClick={openModal}
          style={{
            fontSize: '2.5rem', // Adjust font size for better fit
            marginTop: '10px'
          }}
        >
          {topic?.btnName}
        </button>
      </div>
      <ReactModal
        isOpen={isModalOpen}
        onAfterOpen={openModal}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel='Learn Characters'
      >
        <LearnCharacters closeModal={closeModal} topic={topic} isSpeaking={isSpeaking} />
      </ReactModal> */}
    </>
  )
}

export default Explanation
